// extracted by mini-css-extract-plugin
export default {"container":"AuthBody_container__LgDPV","logo":"AuthBody_logo__DfVIQ"};